import { useMemo } from 'react';
import { usePostgresChangesRealtime } from './usePostgresChangesRealtime';

export type FormsSubmissionTable =
  | 'customer_feedback_submissions'
  | 'memo_submissions'
  | 'cit_submissions'
  | 'pricing_update_submissions'
  | 'certificate_request_submissions'
  | 'account_creation_submissions'
  | 'account_creation_change_log';

type Options = {
  enabled?: boolean;
  /** One or more submission tables to watch. */
  tables: FormsSubmissionTable[];
  /** Optional row filter, e.g. `id=eq.…` for detail pages. */
  filter?: string;
  onChange?: () => void;
};

/**
 * Live-refresh Forms list/detail when submissions change.
 * Requires migration 268.
 */
export function useFormsSubmissionsRealtime(options: Options) {
  const { enabled = true, tables, filter, onChange } = options;
  const listens = useMemo(
    () =>
      tables.map((table) => ({
        schema: 'application_form',
        table,
        ...(filter ? { filter } : {}),
      })),
    [tables, filter],
  );

  usePostgresChangesRealtime({
    enabled: enabled && tables.length > 0,
    channelName: `forms-live:${tables.join('+')}${filter ? `:${filter}` : ''}`,
    portalKind: 'forms',
    syncSecondaryAuth: true,
    debounceMs: 500,
    onChange,
    listens,
  });
}
